import { DiscountTypes } from "@/common/enums";

export default class AlleyTrakSettingsModel {
    isEnabled: boolean = false;
    clientId: string = "";    
}
